module.exports = __webpack_public_path__ + "img/employees.83bf5990.svg";